module.exports = __webpack_public_path__ + "static/media/noti4.84592683.png";